<template>
	<div class="" id="pageTop" style="padding:1rem 1rem 10rem;">
		<div class="row">
            <div class="col-12 alert alert-success" align="center" v-if="showSuccessAlert">
                Please check your email inbox or email SPAM folder for further instructions.
            </div>
            <div class="col-12 alert alert-danger" align="center" v-if="showFailAlert">
                The email address was not found in our system.
            </div>
			<div class="col-12 col-lg-3">
            </div>
            <div class="col-12 col-lg-6">
                <ul class="list-group">
                    <li class="list-group-item">
                        <div class="row">
                            <div class="col-12 my-2">
                                <h4 align="center">Recover password</h4>
                                <p align="center">Please enter your email address to continue.</p>
                            </div>
                            <div class="col-12">
                                <label>Email address</label>
                                <input type="email" class="form-control" v-model="email" />
                            </div>
                            <div class="col-12 my-3">
                                <button class="btn btn-block btn-primary btn-lg" :disabled="!isFormValid || isBusy" @click="btnContinueClick">
                                    <span v-show="!isBusy">Continue</span>
                                    <div class="spinner-border text-light" role="status" v-show="isBusy">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </button>
                            </div>
                            <div class="col-12 my-2" align="center">
                                <button class="btn btn-link" @click="$router.push('/login')">
                                    Return to login.
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-lg-3">
            </div>
		</div>
	</div>
</template>

<script>
    const fb = require("../firebaseConfig")
	export default {
		name: 'ForgotPassword',
		filters: {

		},
		components: {
			
		},
		computed:{
			isFormValid(){
                if(!this.email) return false
                if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email)) return false
                return true
            }
		},
		data(){
			return{
				isBusy: false,
                email: '',
                showSuccessAlert: false,
                showFailAlert: false,
			}
		},
		methods:{
			btnContinueClick(){
                fb.firebase.auth().sendPasswordResetEmail(this.email).then(()=> {
                    this.email = ""
                    this.showSuccessAlert = true
                    this.showFailAlert = false
                }).catch(()=> {
                    this.showFailAlert = true
                })
            }
		},

		mounted(){

        }

	}
</script>
